<template>
  <a-layout class="futuresData">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="content-box">
        <!--        title-->
        <div class="flex align-center">
          <div class="flex align-center jus-center back_box mr-12">
            <img src="@/assets/pic-back.png">
          </div>
          <span class="font-20 color-asset-title">{{ $t('futures.contract_data') }}</span>
        </div>
        <!-- tab/con  -->
        <div class="tab_main">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :title="$t('futures.perpetual_contract_insurance_fund')">
              <div class="flex align-center">
                <div class="flex flex-column align-start">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.insurance_fund_currency') }}</span>
                  <a-dropdown :popup-max-height="false">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">USDT</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>USDT</a-doption>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <!--            kline-->
              <div class="kline"></div>
              <div class="flex align-center jus-end mt-10">
                <span class="font-14 color-blue pointer">{{ $t('futures.learn_insurance_fund') }}</span>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" :title="$t('futures.funding_rate')">
              <div class="flex align-center">
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract_type') }}</span>
                  <a-dropdown :popup-max-height="false">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>{{ $t('common.usdt_contract') }}</a-doption>
                      <a-doption>{{ $t('quotes.coin_margin_futures') }}</a-doption>
                    </template>
                  </a-dropdown>
                </div>
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract') }}</span>
                  <a-dropdown :popup-max-height="true">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>BTCUSDT</a-doption>
                      <a-doption>ETHUSDT</a-doption>
                      <a-doption>BCHUSDT</a-doption>
                      <a-doption>TRXUSDT</a-doption>
                      <a-doption>EOSUSDT</a-doption>
                      <a-doption>XRPUSDT</a-doption>
                      <a-doption>ETCUSDT</a-doption>
                      <a-doption>LTCUSDT</a-doption>
                      <a-doption>LINKUSDT</a-doption>
                      <a-doption>ADAUSDT</a-doption>
                      <a-doption>UNIUSDT</a-doption>
                      <a-doption>FILUSDT</a-doption>
                      <a-doption>DOTUUSDT</a-doption>
                      <a-doption>COMPUSDT</a-doption>
                      <a-doption>AAVEUSDT</a-doption>
                      <a-doption>YFIUSDT</a-doption>
                      <a-doption>QTUMUSDT</a-doption>
                      <a-doption>DOGEUSDT</a-doption>
                      <a-doption>SOLUSDT</a-doption>
                      <a-doption>BNBUSDT</a-doption>
                      <a-doption>LDOUSDT</a-doption>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <div class="kline"></div>
              <div class="flex align-center jus-end mt-10">
                <span class="font-14 color-blue pointer">{{ $t('futures.learn_funding_rate') }}</span>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" :title="$t('futures.index_price')">
              <div class="flex align-center">
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract_type') }}</span>
                  <a-dropdown :popup-max-height="false">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>{{ $t('common.usdt_contract') }}</a-doption>
                      <a-doption>{{ $t('quotes.coin_margin_futures') }}</a-doption>
                    </template>
                  </a-dropdown>
                </div>
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract') }}</span>
                  <a-dropdown :popup-max-height="true">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>BTCUSDT</a-doption>
                      <a-doption>ETHUSDT</a-doption>
                      <a-doption>BCHUSDT</a-doption>
                      <a-doption>TRXUSDT</a-doption>
                      <a-doption>EOSUSDT</a-doption>
                      <a-doption>XRPUSDT</a-doption>
                      <a-doption>ETCUSDT</a-doption>
                      <a-doption>LTCUSDT</a-doption>
                      <a-doption>LINKUSDT</a-doption>
                      <a-doption>ADAUSDT</a-doption>
                      <a-doption>UNIUSDT</a-doption>
                      <a-doption>FILUSDT</a-doption>
                      <a-doption>DOTUUSDT</a-doption>
                      <a-doption>COMPUSDT</a-doption>
                      <a-doption>AAVEUSDT</a-doption>
                      <a-doption>YFIUSDT</a-doption>
                      <a-doption>QTUMUSDT</a-doption>
                      <a-doption>DOGEUSDT</a-doption>
                      <a-doption>SOLUSDT</a-doption>
                      <a-doption>BNBUSDT</a-doption>
                      <a-doption>LDOUSDT</a-doption>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <div class="kline"></div>
              <div class="flex align-center jus-end mt-10">
                <span class="font-14 color-blue pointer">{{ $t('futures.learn_index_price') }}</span>
              </div>
            </a-tab-pane>
            <a-tab-pane key="4" :title="$t('futures.mark_price')">
              <div class="flex align-center">
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract_type') }}</span>
                  <a-dropdown :popup-max-height="false">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>{{ $t('common.usdt_contract') }}</a-doption>
                      <a-doption>{{ $t('quotes.coin_margin_futures') }}</a-doption>
                    </template>
                  </a-dropdown>
                </div>
                <div class="flex flex-column align-start mr-20">
                  <span class="font-14 color-gray mb-5">{{ $t('futures.contract') }}</span>
                  <a-dropdown :popup-max-height="true">
                    <div class="btn flex align-center jus-center pointer">
                      <span class="font-14 color-white">{{ $t('common.usdt_contract') }}</span>
                      <icon-caret-down class="color-gray"/>
                    </div>
                    <template #content>
                      <a-doption>BTCUSDT</a-doption>
                      <a-doption>ETHUSDT</a-doption>
                      <a-doption>BCHUSDT</a-doption>
                      <a-doption>TRXUSDT</a-doption>
                      <a-doption>EOSUSDT</a-doption>
                      <a-doption>XRPUSDT</a-doption>
                      <a-doption>ETCUSDT</a-doption>
                      <a-doption>LTCUSDT</a-doption>
                      <a-doption>LINKUSDT</a-doption>
                      <a-doption>ADAUSDT</a-doption>
                      <a-doption>UNIUSDT</a-doption>
                      <a-doption>FILUSDT</a-doption>
                      <a-doption>DOTUUSDT</a-doption>
                      <a-doption>COMPUSDT</a-doption>
                      <a-doption>AAVEUSDT</a-doption>
                      <a-doption>YFIUSDT</a-doption>
                      <a-doption>QTUMUSDT</a-doption>
                      <a-doption>DOGEUSDT</a-doption>
                      <a-doption>SOLUSDT</a-doption>
                      <a-doption>BNBUSDT</a-doption>
                      <a-doption>LDOUSDT</a-doption>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <div class="kline"></div>
              <div class="flex align-center jus-end mt-10">
                <span class="font-14 color-blue pointer">{{ $t('futures.learn_mark_price') }}</span>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import {defineComponent} from "vue";
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";

export default defineComponent({
  components: {PageNav, Footer}
})
</script>
<style lang="scss" scoped>
@import "./futuresData.scss";
</style>